import { fm } from 'Components/FormatMessage';
import { Container, Item } from 'Components/Grid';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import HistorySection from 'Components/HistorySection';
import { withHistoryContext } from 'Containers/FormContextHandler';
import * as React from 'react';
import { newButton } from 'Routes/Diagnosis/utils/functions';
import { isNil } from 'Utility/ramdaReplacement';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'symptomsDetails'>[] = [];
const SymptomsDetailsHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  treatmentPeriod,
}: IHistoryContext<IDocumentWithTypeV2<'symptomsDetails'>> & {
  treatmentPeriod: IDocumentWithTypeV2<'ninmtTreatmentPeriod'>;
}): React.JSX.Element => {
  const treatmentId = treatmentPeriod._id;

  const symptomsDetails = documents.find(d => d.treatmentPeriodId === treatmentId);

  return (
    <HistorySection
      headerText={<span style={{ fontSize: '2.2rem' }}>{fm('diagnosis.ninmt.symptomsDetails.title')}</span>}
      hasHistoryRows={false}
      newButton={
        startEdit
          ? newButton(
              'symptomsDetails',
              (e: React.MouseEvent): void => {
                if (!treatmentId) return;
                startEdit(symptomsDetails ?? {}, 'symptomsDetails', { treatmentPeriodId: treatmentId })(e);
              },
              'general.edit',
              undefined,
              true,
              !isNil(symptomsDetails?._lockedFor ?? null) ||
                (treatmentPeriod._editing ?? false) ||
                !treatmentPeriod.date,
              isNil(symptomsDetails?._lockedFor) ? 'diagnosis.ninmt.treatmentPeriodDisabledTooltip' : undefined,
              undefined,
              symptomsDetails,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(symptomsDetails)}
    >
      <Container>
        <Item xs={0} md={3} lg={3} />
        <Item xs={12} md={9} lg={9}>
          <HistoryRowVerticalItem
            header={fm('diagnosis.ninmt.symptomsDetails.symptomsDetails')}
            headerWidth={5}
            value={symptomsDetails && symptomsDetails.symptomsDetails ? symptomsDetails.symptomsDetails : '-'}
          />
        </Item>
      </Container>
    </HistorySection>
  );
};

export default withHistoryContext(SymptomsDetailsHistory);
